// Keeps the scale and its "No opinion" checkbox mutually exclusive. There is
// deliberately no click-to-deselect on the blocks: no keyboard gesture clears a
// radio group, so the checkbox is the one route back to an empty answer for
// every input method.
export default () => ({
  valuePicked() {
    const noOpinionCheckbox = this.$root.querySelector('.opinion-scale__no-opinion input');
    if (noOpinionCheckbox) noOpinionCheckbox.checked = false;
  },

  noOpinionToggled(event) {
    if (!event.target.checked) return;

    this.$root.querySelectorAll('.opinion-scale__radio').forEach((radio) => {
      radio.checked = false;
    });
  },
});
